import Vuex from 'vuex';
import Vue from 'vue';
import preferences from './modules/preferences';
import appConfig from './modules/appConfig';
import auth from './modules/auth';
import users from './modules/users';
import globalAlert from './modules/globalAlert';
import account from './modules/account';
import profile from './modules/profile';
import caseGroups from './modules/caseGroups';
import cases from './modules/cases';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    preferences,
    appConfig,
    auth,
    users,
    globalAlert,
    account,
    profile,
    caseGroups,
    cases
  },
  plugins: [createPersistedState({
    key: 'veriscan',
    paths: ['auth', 'appConfig', 'preferences']
  })]
});
